/*eslint-disable*/
export default {
    computed: {
        pages() {
            let shift = 1;
            let leftBorder = Math.max(1, this.currentPage - shift);
            let rightBorder = Math.min(this.lastPage, this.currentPage + shift);
            if (leftBorder === 1) {
                rightBorder = Math.min(this.lastPage, rightBorder + 1 - (this.currentPage - shift));
            } else if (rightBorder === this.lastPage) {
                leftBorder = Math.max(1, leftBorder - (this.currentPage + shift) + rightBorder);
            }
            let pages = [];
            if (leftBorder !== 1) {
                pages.push(1);
                if (leftBorder > 2) {
                    pages.push('...');
                }
            }
            for (let i = leftBorder; i <= rightBorder; i++) {
                pages.push(i);
            }
            if (rightBorder !== this.lastPage) {
                if (rightBorder < this.lastPage - 1) {
                    pages.push('...');
                }
                pages.push(this.lastPage);
            }
            return pages;
        }
    },
}